import React, {Component} from 'react';
import {Icon, ListView, Modal, PullToRefresh, Toast} from 'antd-mobile';
import "./style.less";
import { lifeHome} from "../../service/addLines";
const bbb = require('../../common/image/bbb.jpg');
const bbb1 = require('../../common/image/bbb1.jpg');
let pageIndex = 1;
let pageSize = 10;
export default class FileHome extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            dataSource,
            data:[
                // {
                //     id:0,
                //     picture:`${bbb}`,
                //     name:"牛股了.方法",
                //     city:"昆明市盘龙区",
                //     distance:"14.5km",
                //     content:"本人长期高价收购各种二手电脑，台式机、笔记本，量大从优。本人长期高价收购各种二手电脑，台式机、笔记本，量大从优。本人长期高价收购各种二手电脑，台式…",
                //     imgList:[{img:`${bbb}`,},{img:`${bbb1}`,},{img:`${bbb}`,}],
                //     time:"2020-10-10 14:15",
                // },
                // {
                //     id:111,
                //     picture:`${bbb1}`,
                //     name:"风法师",
                //     city:"昆明市语录区",
                //     distance:"1.4km",
                //     content:"本人长期高价收购各种二手电脑，台式机、笔记本，量大从优。本人长期高价收购各种二手电脑，台式机、笔记本，量大从优。本人长期高价收购各种二手电脑，台式…",
                //     imgList:[{img:`${bbb}`,},{img:`${bbb1}`,},{img:`${bbb}`,}],
                //     time:"2020-10-10 14:15",
                // },
            ],
            point:"",
            address:"",
            isLoading: true,
            notDataLoading:0,
            refreshing:true,
        };
    }
    componentDidMount() {
        console.log(this.props.address,this.props.point);
        pageIndex = 1;
        if(this.props.point !== ""){
            let params = {
                source:1,
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: 1,
                    location:this.props.point.lat + "_" + this.props.point.lng,
                },
            };
            this.getDate(params)
        }
    }
    getDate(params){
        lifeHome(params).then((res)=>{
            if(res.data.code === '0000'){
                if (res.data.data.list.length > 0) {
                    this._setDataSource(res.data.data);
                    // this.setState({data:res.data.data.list})
                } else {
                    this.setState({isLoading: false,notDataLoading:1});
                }
            }else{
                this.setState({notDataLoading:2,isLoading: false});
                Toast.info(res.data.msg,3);
            }
        });
    }
    componentWillReceiveProps(nextProps){
        console.log(nextProps)
        if(nextProps.address !== this.props.address){
            this.setState({
                address:nextProps.address,
                point:nextProps.point.lat + "_" + nextProps.point.lng,
            })
            let params = {
                source:1,
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: 1,
                    location:nextProps.point.lat + "_" + nextProps.point.lng,
                },
            };
            this.getDate(params)

        }
    }
    //数据拼接
    _setDataSource(data) {
        const allData = [...this.state.data, ...data.list];
        this.setState({
            dataSource: this.state.dataSource.cloneWithRows(allData),
            data: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            if(this.state.point !== ""){
                let params = {
                    source:1,
                    token: this.props.userInfo.token,
                    data:{
                        pageSize: pageSize,
                        pageNum: ++pageIndex,
                        location:this.state.point,
                    },
                };
                this.getDate(params);
            }
        }
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noMore">
                <p>没有更多了</p>
            </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noMore">
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    onRefresh  = () => {
        pageIndex = 1;
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum:1,
                location:this.state.point,
            },
        };
        this.setState({ isLoading: true ,refreshing: true,data:[]});
        setTimeout(() => {
            this.getDate(params);
            Toast.info('刷新成功！');
            let top = document.getElementsByClassName("am-list-view-scrollview-content");
            top[0].scrollTop = 0;
            this.setState({isLoading: true, refreshing: false,});
        }, 600);
    };
    render(){
        const _renderRow = (res, index, rowID) => (
            <div className="lifeItem" onClick={()=>this.props.history.push(`/fileDetail/${res.id}`,)} key={rowID}>
                <div className="top">
                    <img src={res.headimgurl}/>
                    <div className="">
                        <div className="name">{res.nickname}</div>
                        <div className="dizhi">{res.releaseAddress} 距离我 <span>{res.limitDistance + 'km'}</span></div>
                    </div>
                </div>
                <div className="con">{res.content}</div>
                <div className="imglist">
                    {
                        res.photoList && res.photoList.map((res,i)=>(
                            <img src={res} key={i} className={(i+1)%3 === 0? 'margin' : null}/>
                        ))
                    }
                </div>
                <div className="time">{res.createDate}</div>
            </div>
        );
        return(

            <div className="lifeList">
                {this.notData()}
                {
                    this.state.notDataLoading == 0  ?
                        <ListView
                            className="invoiceList"
                            ref={el => this.lv = el}
                            dataSource={this.state.dataSource}
                            renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                            renderRow={_renderRow}
                            style={{
                                height: '100%',
                                overflow: 'auto',
                            }}
                            onEndReached={this._onEndReached.bind(this)}
                            scrollRenderAheadDistance={300}
                            onEndReachedThreshold={30}
                            pullToRefresh={<PullToRefresh
                                refreshing={this.state.refreshing}
                                onRefresh={this.onRefresh}
                            />}
                        />: null
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/MtLife/FileHome.js